import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { createCoupon } from 'client/components/entities/coupon'
import {
  BorderEntityInterface,
  FontSizeInterface,
  migrateBackgroundColor,
  migrateBorder,
  migrateFontSize,
  migrateFullBorderType,
  migrateMargin,
  migrateMobileMargin,
} from '../utils/migrateUtils'
import { BackgroundColorInterface } from 'common/types/background-interfaces'

export function migrateCoupon(entity: OldEntityInterface) {
  const coupon = createCoupon(
    entity.parentId,
    entity.options?.placeholder,
    entity.options?.buttonText,
    entity.masterBlockId,
  )

  coupon.id = entity.id
  coupon.htmlAttrId = entity.options.attrId

  if (entity.options.appearance) {
    coupon.appearance.desktop = entity.options.appearance.desktop
    coupon.appearance.mobile = entity.options.appearance.mobile
  }

  coupon.button.text = entity.options.buttonText
  coupon.field.placeholder = entity.options.placeholder

  migrateMargin(coupon, entity)
  migrateMobileMargin(coupon, entity)

  migrateFontSize(
    coupon.button as unknown as FontSizeInterface,
    {
      styles: entity.options.buttonStyles,
      mobileStyles: entity.mobileOptions.buttonStyles,
    } as OldEntityInterface,
  )
  migrateFontSize(
    coupon.field as unknown as FontSizeInterface,
    {
      styles: entity.options.fieldStyles,
      mobileStyles: entity.mobileOptions.fieldStyles,
    } as OldEntityInterface,
  )

  if (entity?.options.fieldStyles?.color) {
    coupon.field.color = entity?.options.fieldStyles?.color
  }
  if (entity?.mobileOptions.fieldStyles?.color) {
    coupon.field.mobileColor = entity?.mobileOptions.fieldStyles?.color
  }
  if (entity?.options.buttonStyles?.color) {
    coupon.button.color = entity?.options.buttonStyles?.color
  }
  if (entity?.mobileOptions.buttonStyles?.color) {
    coupon.button.mobileColor = entity?.mobileOptions.buttonStyles?.color
  }

  migrateBackgroundColor(
    coupon.button as unknown as BackgroundColorInterface,
    {
      styles: entity.options.buttonStyles,
      mobileStyles: entity.mobileOptions.buttonStyles,
    } as OldEntityInterface,
  )

  migrateBorder(
    coupon.button as unknown as BorderEntityInterface,
    {
      styles: entity.options.buttonStyles,
      mobileStyles: entity.mobileOptions.buttonStyles,
    } as OldEntityInterface,
  )
  migrateBorder(
    coupon.field as unknown as BorderEntityInterface,
    {
      styles: entity.options.fieldStyles,
      mobileStyles: entity.mobileOptions.fieldStyles,
    } as OldEntityInterface,
  )

  migrateFullBorderType(
    coupon.button as unknown as BorderEntityInterface,
    {
      styles: entity.options.buttonStyles,
      options: entity.options.buttonOptions,
      mobileStyles: entity.mobileOptions.buttonStyles,
      mobileOptions: entity.mobileOptions.buttonOptions,
    } as OldEntityInterface,
  )
  migrateFullBorderType(
    coupon.field as unknown as BorderEntityInterface,
    {
      styles: entity.options.fieldStyles,
      options: entity.options.fieldOptions,
      mobileStyles: entity.mobileOptions.fieldStyles,
      mobileOptions: entity.mobileOptions.fieldOptions,
    } as OldEntityInterface,
  )

  return coupon
}
